import { InputAdornment } from '@mui/material';
import React from 'react';
import StyledTextField from './styled-text-field';

interface INumberFieldProps {
  value: number;
  handleChange: (value: number) => void;
  handleBlur: (e: React.FocusEvent) => void;
  label: string;
  /* eslint-disable react/require-default-props */
  error?: string;
  isDisabled?: boolean;
  prefixValue?: string;
  suffixValue?: string;
  /* eslint-enable react/require-default-props */
}

export default function NumberFieldControl({
  handleChange,
  handleBlur,
  label,
  value,
  isDisabled = false,
  error = '',
  prefixValue,
  suffixValue
}: INumberFieldProps) {
  return (
    <StyledTextField
      id={label}
      type='number'
      disabled={isDisabled}
      size='small'
      variant='outlined'
      value={value}
      fullWidth
      onChange={(e) => {
        const enteredValue =
          typeof e.target.value === 'string' && e.target.value
            ? Number(e.target.value)
            : (e.target.value as unknown as number);
        handleChange(enteredValue);
      }}
      onBlur={(e) => {
        handleBlur(e);
      }}
      error={!!error}
      helperText={error || ''}
      InputProps={{
        startAdornment: prefixValue && (
          <InputAdornment position='start'>{prefixValue}</InputAdornment>
        ),
        endAdornment: suffixValue && (
          <InputAdornment position='end'>{suffixValue} </InputAdornment>
        )
      }}
    />
  );
}
